<mat-nav-list>
    <div #navList
         *ngLet="sidebarSections$ | async as sidebarSections">
        <ng-container *ngIf="isHost; else tenant">
            <ng-container *ngFor="let section of sidebarSections">
                <ng-container *ngFor="let page of section.pages">
                    <ng-container *ngTemplateOutlet="sidebarPageItem; context: { $implicit: page }"></ng-container>
                </ng-container>
            </ng-container>
        </ng-container>

        <ng-template #tenant>
            <ng-container *ngFor="let section of sidebarSections">
                <ui-sidebar-accordion [fontIcon]="section.metadata.fontIcon"
                                      [svgIcon]="section.metadata.svgIcon"
                                      [pages]="section.pages"
                                      [isActive]="containsActive(section.pages) | async"
                                      [itemTemplate]="sidebarPageItem"
                                      [headerText]="section.metadata.translateKey | translate | uppercase"
                                      [expanded]="expansionStates[section.name]"
                                      (expandedChange)="onExpandedChange(section.name, $event)">
                </ui-sidebar-accordion>
            </ng-container>

        </ng-template>

    </div>
</mat-nav-list>

<ng-template #sidebarPageItem
             let-page>
    <a [routerLink]="[page.routerLink]"
       [class.active]="isActive(page) | async"
       matRipple
       mat-list-item>
        <mat-icon *ngIf="page.svgIcon"
                  [svgIcon]="page.svgIcon"
                  mat-list-icon
                  class="ui-svg-icon"></mat-icon>
        <mat-icon *ngIf="!page.svgIcon"
                  mat-list-icon>{{page.icon}}</mat-icon>
        <span matLine>
            {{page.translationKey | translate}}
        </span>
    </a>
</ng-template>
